
import * as ActionTypes from '../actionTypes';

export default (state={},action) => {

    switch(action.type){
        case ActionTypes.REQUEST_TRANSACTIONS_INFO:                
            return {
                ...state,
                loading:true,
                error:false,
                errorInfo:null
            }        
        case ActionTypes.RECEIVED_TRANSACTIONS_INFO:
            return {
                ...state,
                loading:false,
                response:action.res,
                error:false,
                errorInfo:null
            }
        case ActionTypes.ERROR_TRANSACTIONS_INFO:
            return{
                ...state,
                loading:false,
                error:true,
                errorInfo:action.err
            }
        case ActionTypes.CLEAR_TRANSACTIONS_INFO:
            return {}
        default: return state;
    }
} 